import { BehaviorSubject } from 'rxjs'
import { DateUtil } from 'src/framework/commons/DateUtils';

/*export const INITIAL_STATE = {
  distribuidor: null,
  revenda: null,
  etapaVenda: { text: 'Todos', value: '', field: '', not_in_field: '', not_in_query: [] },
  endDate: new Date().toISOString(),
  startDate: DateUtil.decMonth(new Date(), 1).toISOString(),
}*/

export const INITIAL_STATE = {
  distribuidor: null,
  revenda: null,
  statusProjeto: { text: 'Todos', value: '', field: '' },
  endDate: new Date().toISOString(),
  startDate: DateUtil.decMonth(new Date(), 1).toISOString(),
}

export interface EtapaVendaOption {
  text: string;
  value: string;
  field: string;
  not_in_field: string;
  not_in_query: string[]
}
export interface StatusProjetoOption {
  text: string;
  value: string;
  field: string;
}

/*export interface FiltersStoreType {
  startDate: string;
  endDate: string;
  etapaVenda: EtapaVendaOption,
  distribuidor: { nome: string, id: string } | null
  revenda: { nome: string, id: string } | null
}*/
export interface FiltersStoreType {
  startDate: string;
  endDate: string;
  statusProjeto: StatusProjetoOption,
  distribuidor: { nome: string, id: string } | null
  revenda: { nome: string, id: string } | null
}

export const dashboardFilterStore$ = new BehaviorSubject<FiltersStoreType>(INITIAL_STATE);

export const setDashboardFilter = (field: keyof FiltersStoreType, value: any) => {
  dashboardFilterStore$.next({ ...dashboardFilterStore$.value, [field]: value })
}

export const clearDashboardFilter = () => {
  dashboardFilterStore$.next(INITIAL_STATE)
}